import { useEffect } from 'react';
import { setUserIsTabbing, unsetUserIsTabbing } from 'actions/ui';
import { selectUserIsTabbing } from 'selectors/ui';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { IS_TABBING_CLASS } from './constants';

const ConditionalFocus = (): null => {
  const isTabbing = useAppSelector(selectUserIsTabbing);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const onKeyDown = ({ key }: KeyboardEvent): void => {
      const { classList } = document.body;
      if (key === 'Tab') {
        if (!isTabbing) {
          dispatch(setUserIsTabbing());
        }
        if (!classList.contains(IS_TABBING_CLASS)) {
          classList.add(IS_TABBING_CLASS);
        }
      }
    };

    const onClick = (): void => {
      const { classList } = document.body;
      if (isTabbing) {
        dispatch(unsetUserIsTabbing());
      }
      if (classList.contains(IS_TABBING_CLASS)) {
        classList.remove(IS_TABBING_CLASS);
      }
    };

    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('click', onClick);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('click', onClick);
    };
  }, [isTabbing, dispatch]);

  return null;
};

export default ConditionalFocus;
